/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  queryOptions as queryOptionsBuilder,
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  ActiveMailProviderSettings,
  AdminAccessRestrictionSettings,
  AppServerSettings,
  AttachmentServiceSettings,
  BaseSmtpSettings,
  DocusignSettings,
  ExternalApiSettings,
  Features,
  GraphSettings,
  LicenseData,
  ProxySettings,
  ReminderSettings,
  SsoSettings,
  SystemNotificationSmtpSettings,
  TestMailSettingsRequest,
  TestSmtpSettingsResult,
  TixlySettings,
  TrustedProxySettings,
  UpdateServiceSettings,
  ValidateDirectoryPathRequest,
  WebsiteSettings
} from '../../model';

import { customInstance } from '../../../mutator.ts';
import type { ErrorType , BodyType } from '../../../mutator.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGetUpdateServiceSettingsUrl = () => {




  return `/api/Settings/GetUpdateServiceSettings`
}

export const getUpdateServiceSettings = async ( options?: Parameters<typeof customInstance>[1]): Promise<UpdateServiceSettings> => {

  return customInstance<UpdateServiceSettings>(getGetUpdateServiceSettingsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetUpdateServiceSettingsQueryKey = () => {
    return [
    `/api/Settings/GetUpdateServiceSettings`
    ] as const;
    }


export const getGetUpdateServiceSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getUpdateServiceSettings>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUpdateServiceSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUpdateServiceSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUpdateServiceSettings>>> = ({ signal }) => getUpdateServiceSettings({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUpdateServiceSettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUpdateServiceSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getUpdateServiceSettings>>>
export type GetUpdateServiceSettingsQueryError = ErrorType<unknown>


export function useGetUpdateServiceSettings<TData = Awaited<ReturnType<typeof getUpdateServiceSettings>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUpdateServiceSettings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUpdateServiceSettings>>,
          TError,
          Awaited<ReturnType<typeof getUpdateServiceSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUpdateServiceSettings<TData = Awaited<ReturnType<typeof getUpdateServiceSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUpdateServiceSettings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUpdateServiceSettings>>,
          TError,
          Awaited<ReturnType<typeof getUpdateServiceSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUpdateServiceSettings<TData = Awaited<ReturnType<typeof getUpdateServiceSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUpdateServiceSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetUpdateServiceSettings<TData = Awaited<ReturnType<typeof getUpdateServiceSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUpdateServiceSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUpdateServiceSettingsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetUpdateServiceSettingsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getUpdateServiceSettings>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUpdateServiceSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUpdateServiceSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUpdateServiceSettings>>> = ({ signal }) => getUpdateServiceSettings({ signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUpdateServiceSettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetUpdateServiceSettingsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getUpdateServiceSettings>>>
export type GetUpdateServiceSettingsSuspenseQueryError = ErrorType<unknown>


export function useGetUpdateServiceSettingsSuspense<TData = Awaited<ReturnType<typeof getUpdateServiceSettings>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUpdateServiceSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUpdateServiceSettingsSuspense<TData = Awaited<ReturnType<typeof getUpdateServiceSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUpdateServiceSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUpdateServiceSettingsSuspense<TData = Awaited<ReturnType<typeof getUpdateServiceSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUpdateServiceSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetUpdateServiceSettingsSuspense<TData = Awaited<ReturnType<typeof getUpdateServiceSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUpdateServiceSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUpdateServiceSettingsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getSetUpdateServiceSettingsUrl = () => {




  return `/api/Settings/SetUpdateServiceSettings`
}

export const setUpdateServiceSettings = async (updateServiceSettings?: UpdateServiceSettings, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<void>(getSetUpdateServiceSettingsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateServiceSettings)
  }
);}





export const getSetUpdateServiceSettingsMutationKey = () => ['setUpdateServiceSettings'] as const;

export const getSetUpdateServiceSettingsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setUpdateServiceSettings>>, TError,SetUpdateServiceSettingsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof setUpdateServiceSettings>>, TError,SetUpdateServiceSettingsMutationVariables, TContext> => {

const mutationKey = getSetUpdateServiceSettingsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setUpdateServiceSettings>>, SetUpdateServiceSettingsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  setUpdateServiceSettings(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetUpdateServiceSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof setUpdateServiceSettings>>>
    export type SetUpdateServiceSettingsMutationBody = BodyType<UpdateServiceSettings> | undefined
    export type SetUpdateServiceSettingsMutationError = ErrorType<unknown>
    export type SetUpdateServiceSettingsMutationVariables = {data?: BodyType<UpdateServiceSettings>}

    export const useSetUpdateServiceSettings = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setUpdateServiceSettings>>, TError,SetUpdateServiceSettingsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setUpdateServiceSettings>>,
        TError,
        SetUpdateServiceSettingsMutationVariables,
        TContext
      > => {
      return useMutation(getSetUpdateServiceSettingsMutationOptions(options), queryClient);
    }
    export const getGetAttachmentServiceSettingsUrl = () => {




  return `/api/Settings/GetAttachmentServiceSettings`
}

export const getAttachmentServiceSettings = async ( options?: Parameters<typeof customInstance>[1]): Promise<AttachmentServiceSettings> => {

  return customInstance<AttachmentServiceSettings>(getGetAttachmentServiceSettingsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAttachmentServiceSettingsQueryKey = () => {
    return [
    `/api/Settings/GetAttachmentServiceSettings`
    ] as const;
    }


export const getGetAttachmentServiceSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getAttachmentServiceSettings>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAttachmentServiceSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAttachmentServiceSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAttachmentServiceSettings>>> = ({ signal }) => getAttachmentServiceSettings({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAttachmentServiceSettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAttachmentServiceSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getAttachmentServiceSettings>>>
export type GetAttachmentServiceSettingsQueryError = ErrorType<unknown>


export function useGetAttachmentServiceSettings<TData = Awaited<ReturnType<typeof getAttachmentServiceSettings>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAttachmentServiceSettings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAttachmentServiceSettings>>,
          TError,
          Awaited<ReturnType<typeof getAttachmentServiceSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAttachmentServiceSettings<TData = Awaited<ReturnType<typeof getAttachmentServiceSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAttachmentServiceSettings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAttachmentServiceSettings>>,
          TError,
          Awaited<ReturnType<typeof getAttachmentServiceSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAttachmentServiceSettings<TData = Awaited<ReturnType<typeof getAttachmentServiceSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAttachmentServiceSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAttachmentServiceSettings<TData = Awaited<ReturnType<typeof getAttachmentServiceSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAttachmentServiceSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAttachmentServiceSettingsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetAttachmentServiceSettingsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getAttachmentServiceSettings>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAttachmentServiceSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAttachmentServiceSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAttachmentServiceSettings>>> = ({ signal }) => getAttachmentServiceSettings({ signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAttachmentServiceSettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetAttachmentServiceSettingsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getAttachmentServiceSettings>>>
export type GetAttachmentServiceSettingsSuspenseQueryError = ErrorType<unknown>


export function useGetAttachmentServiceSettingsSuspense<TData = Awaited<ReturnType<typeof getAttachmentServiceSettings>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAttachmentServiceSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAttachmentServiceSettingsSuspense<TData = Awaited<ReturnType<typeof getAttachmentServiceSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAttachmentServiceSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAttachmentServiceSettingsSuspense<TData = Awaited<ReturnType<typeof getAttachmentServiceSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAttachmentServiceSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAttachmentServiceSettingsSuspense<TData = Awaited<ReturnType<typeof getAttachmentServiceSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAttachmentServiceSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAttachmentServiceSettingsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getSetAttachmentServiceSettingsUrl = () => {




  return `/api/Settings/SetAttachmentServiceSettings`
}

export const setAttachmentServiceSettings = async (attachmentServiceSettings?: AttachmentServiceSettings, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<void>(getSetAttachmentServiceSettingsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(attachmentServiceSettings)
  }
);}





export const getSetAttachmentServiceSettingsMutationKey = () => ['setAttachmentServiceSettings'] as const;

export const getSetAttachmentServiceSettingsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setAttachmentServiceSettings>>, TError,SetAttachmentServiceSettingsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof setAttachmentServiceSettings>>, TError,SetAttachmentServiceSettingsMutationVariables, TContext> => {

const mutationKey = getSetAttachmentServiceSettingsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setAttachmentServiceSettings>>, SetAttachmentServiceSettingsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  setAttachmentServiceSettings(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetAttachmentServiceSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof setAttachmentServiceSettings>>>
    export type SetAttachmentServiceSettingsMutationBody = BodyType<AttachmentServiceSettings> | undefined
    export type SetAttachmentServiceSettingsMutationError = ErrorType<unknown>
    export type SetAttachmentServiceSettingsMutationVariables = {data?: BodyType<AttachmentServiceSettings>}

    export const useSetAttachmentServiceSettings = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setAttachmentServiceSettings>>, TError,SetAttachmentServiceSettingsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setAttachmentServiceSettings>>,
        TError,
        SetAttachmentServiceSettingsMutationVariables,
        TContext
      > => {
      return useMutation(getSetAttachmentServiceSettingsMutationOptions(options), queryClient);
    }
    export const getGetBaseSmtpSettingsUrl = () => {




  return `/api/Settings/GetBaseSmtpSettings`
}

export const getBaseSmtpSettings = async ( options?: Parameters<typeof customInstance>[1]): Promise<BaseSmtpSettings> => {

  return customInstance<BaseSmtpSettings>(getGetBaseSmtpSettingsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetBaseSmtpSettingsQueryKey = () => {
    return [
    `/api/Settings/GetBaseSmtpSettings`
    ] as const;
    }


export const getGetBaseSmtpSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getBaseSmtpSettings>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBaseSmtpSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBaseSmtpSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBaseSmtpSettings>>> = ({ signal }) => getBaseSmtpSettings({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBaseSmtpSettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBaseSmtpSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getBaseSmtpSettings>>>
export type GetBaseSmtpSettingsQueryError = ErrorType<unknown>


export function useGetBaseSmtpSettings<TData = Awaited<ReturnType<typeof getBaseSmtpSettings>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBaseSmtpSettings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBaseSmtpSettings>>,
          TError,
          Awaited<ReturnType<typeof getBaseSmtpSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBaseSmtpSettings<TData = Awaited<ReturnType<typeof getBaseSmtpSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBaseSmtpSettings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBaseSmtpSettings>>,
          TError,
          Awaited<ReturnType<typeof getBaseSmtpSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBaseSmtpSettings<TData = Awaited<ReturnType<typeof getBaseSmtpSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBaseSmtpSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetBaseSmtpSettings<TData = Awaited<ReturnType<typeof getBaseSmtpSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBaseSmtpSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBaseSmtpSettingsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetBaseSmtpSettingsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getBaseSmtpSettings>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBaseSmtpSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBaseSmtpSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBaseSmtpSettings>>> = ({ signal }) => getBaseSmtpSettings({ signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBaseSmtpSettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetBaseSmtpSettingsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getBaseSmtpSettings>>>
export type GetBaseSmtpSettingsSuspenseQueryError = ErrorType<unknown>


export function useGetBaseSmtpSettingsSuspense<TData = Awaited<ReturnType<typeof getBaseSmtpSettings>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBaseSmtpSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBaseSmtpSettingsSuspense<TData = Awaited<ReturnType<typeof getBaseSmtpSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBaseSmtpSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBaseSmtpSettingsSuspense<TData = Awaited<ReturnType<typeof getBaseSmtpSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBaseSmtpSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetBaseSmtpSettingsSuspense<TData = Awaited<ReturnType<typeof getBaseSmtpSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBaseSmtpSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBaseSmtpSettingsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getSetBaseSmtpSettingsUrl = () => {




  return `/api/Settings/SetBaseSmtpSettings`
}

export const setBaseSmtpSettings = async (baseSmtpSettings?: BaseSmtpSettings, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<void>(getSetBaseSmtpSettingsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(baseSmtpSettings)
  }
);}





export const getSetBaseSmtpSettingsMutationKey = () => ['setBaseSmtpSettings'] as const;

export const getSetBaseSmtpSettingsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setBaseSmtpSettings>>, TError,SetBaseSmtpSettingsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof setBaseSmtpSettings>>, TError,SetBaseSmtpSettingsMutationVariables, TContext> => {

const mutationKey = getSetBaseSmtpSettingsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setBaseSmtpSettings>>, SetBaseSmtpSettingsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  setBaseSmtpSettings(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetBaseSmtpSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof setBaseSmtpSettings>>>
    export type SetBaseSmtpSettingsMutationBody = BodyType<BaseSmtpSettings> | undefined
    export type SetBaseSmtpSettingsMutationError = ErrorType<unknown>
    export type SetBaseSmtpSettingsMutationVariables = {data?: BodyType<BaseSmtpSettings>}

    export const useSetBaseSmtpSettings = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setBaseSmtpSettings>>, TError,SetBaseSmtpSettingsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setBaseSmtpSettings>>,
        TError,
        SetBaseSmtpSettingsMutationVariables,
        TContext
      > => {
      return useMutation(getSetBaseSmtpSettingsMutationOptions(options), queryClient);
    }
    export const getGetSystemNotificationSmtpSettingsUrl = () => {




  return `/api/Settings/GetSystemNotificationSmtpSettings`
}

export const getSystemNotificationSmtpSettings = async ( options?: Parameters<typeof customInstance>[1]): Promise<SystemNotificationSmtpSettings> => {

  return customInstance<SystemNotificationSmtpSettings>(getGetSystemNotificationSmtpSettingsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSystemNotificationSmtpSettingsQueryKey = () => {
    return [
    `/api/Settings/GetSystemNotificationSmtpSettings`
    ] as const;
    }


export const getGetSystemNotificationSmtpSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getSystemNotificationSmtpSettings>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSystemNotificationSmtpSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSystemNotificationSmtpSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSystemNotificationSmtpSettings>>> = ({ signal }) => getSystemNotificationSmtpSettings({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSystemNotificationSmtpSettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSystemNotificationSmtpSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getSystemNotificationSmtpSettings>>>
export type GetSystemNotificationSmtpSettingsQueryError = ErrorType<unknown>


export function useGetSystemNotificationSmtpSettings<TData = Awaited<ReturnType<typeof getSystemNotificationSmtpSettings>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSystemNotificationSmtpSettings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSystemNotificationSmtpSettings>>,
          TError,
          Awaited<ReturnType<typeof getSystemNotificationSmtpSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSystemNotificationSmtpSettings<TData = Awaited<ReturnType<typeof getSystemNotificationSmtpSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSystemNotificationSmtpSettings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSystemNotificationSmtpSettings>>,
          TError,
          Awaited<ReturnType<typeof getSystemNotificationSmtpSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSystemNotificationSmtpSettings<TData = Awaited<ReturnType<typeof getSystemNotificationSmtpSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSystemNotificationSmtpSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetSystemNotificationSmtpSettings<TData = Awaited<ReturnType<typeof getSystemNotificationSmtpSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSystemNotificationSmtpSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSystemNotificationSmtpSettingsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetSystemNotificationSmtpSettingsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getSystemNotificationSmtpSettings>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSystemNotificationSmtpSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSystemNotificationSmtpSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSystemNotificationSmtpSettings>>> = ({ signal }) => getSystemNotificationSmtpSettings({ signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSystemNotificationSmtpSettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetSystemNotificationSmtpSettingsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getSystemNotificationSmtpSettings>>>
export type GetSystemNotificationSmtpSettingsSuspenseQueryError = ErrorType<unknown>


export function useGetSystemNotificationSmtpSettingsSuspense<TData = Awaited<ReturnType<typeof getSystemNotificationSmtpSettings>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSystemNotificationSmtpSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSystemNotificationSmtpSettingsSuspense<TData = Awaited<ReturnType<typeof getSystemNotificationSmtpSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSystemNotificationSmtpSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSystemNotificationSmtpSettingsSuspense<TData = Awaited<ReturnType<typeof getSystemNotificationSmtpSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSystemNotificationSmtpSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetSystemNotificationSmtpSettingsSuspense<TData = Awaited<ReturnType<typeof getSystemNotificationSmtpSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSystemNotificationSmtpSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSystemNotificationSmtpSettingsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getSetSystemNotificationSmtpSettingsUrl = () => {




  return `/api/Settings/SetSystemNotificationSmtpSettings`
}

export const setSystemNotificationSmtpSettings = async (systemNotificationSmtpSettings?: SystemNotificationSmtpSettings, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<void>(getSetSystemNotificationSmtpSettingsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(systemNotificationSmtpSettings)
  }
);}





export const getSetSystemNotificationSmtpSettingsMutationKey = () => ['setSystemNotificationSmtpSettings'] as const;

export const getSetSystemNotificationSmtpSettingsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setSystemNotificationSmtpSettings>>, TError,SetSystemNotificationSmtpSettingsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof setSystemNotificationSmtpSettings>>, TError,SetSystemNotificationSmtpSettingsMutationVariables, TContext> => {

const mutationKey = getSetSystemNotificationSmtpSettingsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setSystemNotificationSmtpSettings>>, SetSystemNotificationSmtpSettingsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  setSystemNotificationSmtpSettings(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetSystemNotificationSmtpSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof setSystemNotificationSmtpSettings>>>
    export type SetSystemNotificationSmtpSettingsMutationBody = BodyType<SystemNotificationSmtpSettings> | undefined
    export type SetSystemNotificationSmtpSettingsMutationError = ErrorType<unknown>
    export type SetSystemNotificationSmtpSettingsMutationVariables = {data?: BodyType<SystemNotificationSmtpSettings>}

    export const useSetSystemNotificationSmtpSettings = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setSystemNotificationSmtpSettings>>, TError,SetSystemNotificationSmtpSettingsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setSystemNotificationSmtpSettings>>,
        TError,
        SetSystemNotificationSmtpSettingsMutationVariables,
        TContext
      > => {
      return useMutation(getSetSystemNotificationSmtpSettingsMutationOptions(options), queryClient);
    }
    export const getGetGraphSettingsUrl = () => {




  return `/api/Settings/GetGraphSettings`
}

export const getGraphSettings = async ( options?: Parameters<typeof customInstance>[1]): Promise<GraphSettings> => {

  return customInstance<GraphSettings>(getGetGraphSettingsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetGraphSettingsQueryKey = () => {
    return [
    `/api/Settings/GetGraphSettings`
    ] as const;
    }


export const getGetGraphSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getGraphSettings>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGraphSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGraphSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGraphSettings>>> = ({ signal }) => getGraphSettings({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getGraphSettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetGraphSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getGraphSettings>>>
export type GetGraphSettingsQueryError = ErrorType<unknown>


export function useGetGraphSettings<TData = Awaited<ReturnType<typeof getGraphSettings>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGraphSettings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGraphSettings>>,
          TError,
          Awaited<ReturnType<typeof getGraphSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGraphSettings<TData = Awaited<ReturnType<typeof getGraphSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGraphSettings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGraphSettings>>,
          TError,
          Awaited<ReturnType<typeof getGraphSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGraphSettings<TData = Awaited<ReturnType<typeof getGraphSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGraphSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetGraphSettings<TData = Awaited<ReturnType<typeof getGraphSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGraphSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetGraphSettingsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetGraphSettingsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getGraphSettings>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getGraphSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGraphSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGraphSettings>>> = ({ signal }) => getGraphSettings({ signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getGraphSettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetGraphSettingsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getGraphSettings>>>
export type GetGraphSettingsSuspenseQueryError = ErrorType<unknown>


export function useGetGraphSettingsSuspense<TData = Awaited<ReturnType<typeof getGraphSettings>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getGraphSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGraphSettingsSuspense<TData = Awaited<ReturnType<typeof getGraphSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getGraphSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGraphSettingsSuspense<TData = Awaited<ReturnType<typeof getGraphSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getGraphSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetGraphSettingsSuspense<TData = Awaited<ReturnType<typeof getGraphSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getGraphSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetGraphSettingsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getSetGraphSettingsUrl = () => {




  return `/api/Settings/SetGraphSettings`
}

export const setGraphSettings = async (graphSettings?: GraphSettings, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<void>(getSetGraphSettingsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(graphSettings)
  }
);}





export const getSetGraphSettingsMutationKey = () => ['setGraphSettings'] as const;

export const getSetGraphSettingsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setGraphSettings>>, TError,SetGraphSettingsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof setGraphSettings>>, TError,SetGraphSettingsMutationVariables, TContext> => {

const mutationKey = getSetGraphSettingsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setGraphSettings>>, SetGraphSettingsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  setGraphSettings(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetGraphSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof setGraphSettings>>>
    export type SetGraphSettingsMutationBody = BodyType<GraphSettings> | undefined
    export type SetGraphSettingsMutationError = ErrorType<unknown>
    export type SetGraphSettingsMutationVariables = {data?: BodyType<GraphSettings>}

    export const useSetGraphSettings = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setGraphSettings>>, TError,SetGraphSettingsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setGraphSettings>>,
        TError,
        SetGraphSettingsMutationVariables,
        TContext
      > => {
      return useMutation(getSetGraphSettingsMutationOptions(options), queryClient);
    }
    export const getTestMailSettingsUrl = () => {




  return `/api/Settings/TestMailSettings`
}

export const testMailSettings = async (testMailSettingsRequest?: TestMailSettingsRequest, options?: Parameters<typeof customInstance>[1]): Promise<TestSmtpSettingsResult> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<TestSmtpSettingsResult>(getTestMailSettingsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(testMailSettingsRequest)
  }
);}





export const getTestMailSettingsMutationKey = () => ['testMailSettings'] as const;

export const getTestMailSettingsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testMailSettings>>, TError,TestMailSettingsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof testMailSettings>>, TError,TestMailSettingsMutationVariables, TContext> => {

const mutationKey = getTestMailSettingsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof testMailSettings>>, TestMailSettingsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  testMailSettings(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TestMailSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof testMailSettings>>>
    export type TestMailSettingsMutationBody = BodyType<TestMailSettingsRequest> | undefined
    export type TestMailSettingsMutationError = ErrorType<unknown>
    export type TestMailSettingsMutationVariables = {data?: BodyType<TestMailSettingsRequest>}

    export const useTestMailSettings = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testMailSettings>>, TError,TestMailSettingsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof testMailSettings>>,
        TError,
        TestMailSettingsMutationVariables,
        TContext
      > => {
      return useMutation(getTestMailSettingsMutationOptions(options), queryClient);
    }
    export const getGetAppServerSettingsUrl = () => {




  return `/api/Settings/GetAppServerSettings`
}

export const getAppServerSettings = async ( options?: Parameters<typeof customInstance>[1]): Promise<AppServerSettings> => {

  return customInstance<AppServerSettings>(getGetAppServerSettingsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAppServerSettingsQueryKey = () => {
    return [
    `/api/Settings/GetAppServerSettings`
    ] as const;
    }


export const getGetAppServerSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getAppServerSettings>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppServerSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAppServerSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAppServerSettings>>> = ({ signal }) => getAppServerSettings({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAppServerSettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAppServerSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getAppServerSettings>>>
export type GetAppServerSettingsQueryError = ErrorType<unknown>


export function useGetAppServerSettings<TData = Awaited<ReturnType<typeof getAppServerSettings>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppServerSettings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAppServerSettings>>,
          TError,
          Awaited<ReturnType<typeof getAppServerSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAppServerSettings<TData = Awaited<ReturnType<typeof getAppServerSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppServerSettings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAppServerSettings>>,
          TError,
          Awaited<ReturnType<typeof getAppServerSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAppServerSettings<TData = Awaited<ReturnType<typeof getAppServerSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppServerSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAppServerSettings<TData = Awaited<ReturnType<typeof getAppServerSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppServerSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAppServerSettingsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetAppServerSettingsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getAppServerSettings>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAppServerSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAppServerSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAppServerSettings>>> = ({ signal }) => getAppServerSettings({ signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAppServerSettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetAppServerSettingsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getAppServerSettings>>>
export type GetAppServerSettingsSuspenseQueryError = ErrorType<unknown>


export function useGetAppServerSettingsSuspense<TData = Awaited<ReturnType<typeof getAppServerSettings>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAppServerSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAppServerSettingsSuspense<TData = Awaited<ReturnType<typeof getAppServerSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAppServerSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAppServerSettingsSuspense<TData = Awaited<ReturnType<typeof getAppServerSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAppServerSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAppServerSettingsSuspense<TData = Awaited<ReturnType<typeof getAppServerSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAppServerSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAppServerSettingsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getSetAppServerSettingsUrl = () => {




  return `/api/Settings/SetAppServerSettings`
}

export const setAppServerSettings = async (appServerSettings?: AppServerSettings, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<void>(getSetAppServerSettingsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(appServerSettings)
  }
);}





export const getSetAppServerSettingsMutationKey = () => ['setAppServerSettings'] as const;

export const getSetAppServerSettingsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setAppServerSettings>>, TError,SetAppServerSettingsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof setAppServerSettings>>, TError,SetAppServerSettingsMutationVariables, TContext> => {

const mutationKey = getSetAppServerSettingsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setAppServerSettings>>, SetAppServerSettingsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  setAppServerSettings(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetAppServerSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof setAppServerSettings>>>
    export type SetAppServerSettingsMutationBody = BodyType<AppServerSettings> | undefined
    export type SetAppServerSettingsMutationError = ErrorType<unknown>
    export type SetAppServerSettingsMutationVariables = {data?: BodyType<AppServerSettings>}

    export const useSetAppServerSettings = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setAppServerSettings>>, TError,SetAppServerSettingsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setAppServerSettings>>,
        TError,
        SetAppServerSettingsMutationVariables,
        TContext
      > => {
      return useMutation(getSetAppServerSettingsMutationOptions(options), queryClient);
    }
    export const getGetWebsiteSettingsUrl = () => {




  return `/api/Settings/GetWebsiteSettings`
}

export const getWebsiteSettings = async ( options?: Parameters<typeof customInstance>[1]): Promise<WebsiteSettings> => {

  return customInstance<WebsiteSettings>(getGetWebsiteSettingsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetWebsiteSettingsQueryKey = () => {
    return [
    `/api/Settings/GetWebsiteSettings`
    ] as const;
    }


export const getGetWebsiteSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getWebsiteSettings>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWebsiteSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWebsiteSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWebsiteSettings>>> = ({ signal }) => getWebsiteSettings({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWebsiteSettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetWebsiteSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getWebsiteSettings>>>
export type GetWebsiteSettingsQueryError = ErrorType<unknown>


export function useGetWebsiteSettings<TData = Awaited<ReturnType<typeof getWebsiteSettings>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWebsiteSettings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWebsiteSettings>>,
          TError,
          Awaited<ReturnType<typeof getWebsiteSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWebsiteSettings<TData = Awaited<ReturnType<typeof getWebsiteSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWebsiteSettings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWebsiteSettings>>,
          TError,
          Awaited<ReturnType<typeof getWebsiteSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWebsiteSettings<TData = Awaited<ReturnType<typeof getWebsiteSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWebsiteSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetWebsiteSettings<TData = Awaited<ReturnType<typeof getWebsiteSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWebsiteSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetWebsiteSettingsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetWebsiteSettingsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getWebsiteSettings>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWebsiteSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWebsiteSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWebsiteSettings>>> = ({ signal }) => getWebsiteSettings({ signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWebsiteSettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetWebsiteSettingsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getWebsiteSettings>>>
export type GetWebsiteSettingsSuspenseQueryError = ErrorType<unknown>


export function useGetWebsiteSettingsSuspense<TData = Awaited<ReturnType<typeof getWebsiteSettings>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWebsiteSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWebsiteSettingsSuspense<TData = Awaited<ReturnType<typeof getWebsiteSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWebsiteSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWebsiteSettingsSuspense<TData = Awaited<ReturnType<typeof getWebsiteSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWebsiteSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetWebsiteSettingsSuspense<TData = Awaited<ReturnType<typeof getWebsiteSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWebsiteSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetWebsiteSettingsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getSetWebsiteSettingsUrl = () => {




  return `/api/Settings/SetWebsiteSettings`
}

export const setWebsiteSettings = async (websiteSettings?: WebsiteSettings, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<void>(getSetWebsiteSettingsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(websiteSettings)
  }
);}





export const getSetWebsiteSettingsMutationKey = () => ['setWebsiteSettings'] as const;

export const getSetWebsiteSettingsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setWebsiteSettings>>, TError,SetWebsiteSettingsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof setWebsiteSettings>>, TError,SetWebsiteSettingsMutationVariables, TContext> => {

const mutationKey = getSetWebsiteSettingsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setWebsiteSettings>>, SetWebsiteSettingsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  setWebsiteSettings(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetWebsiteSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof setWebsiteSettings>>>
    export type SetWebsiteSettingsMutationBody = BodyType<WebsiteSettings> | undefined
    export type SetWebsiteSettingsMutationError = ErrorType<unknown>
    export type SetWebsiteSettingsMutationVariables = {data?: BodyType<WebsiteSettings>}

    export const useSetWebsiteSettings = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setWebsiteSettings>>, TError,SetWebsiteSettingsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setWebsiteSettings>>,
        TError,
        SetWebsiteSettingsMutationVariables,
        TContext
      > => {
      return useMutation(getSetWebsiteSettingsMutationOptions(options), queryClient);
    }
    export const getGetFeatureSettingsUrl = () => {




  return `/api/Settings/GetFeatureSettings`
}

export const getFeatureSettings = async ( options?: Parameters<typeof customInstance>[1]): Promise<Features> => {

  return customInstance<Features>(getGetFeatureSettingsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetFeatureSettingsQueryKey = () => {
    return [
    `/api/Settings/GetFeatureSettings`
    ] as const;
    }


export const getGetFeatureSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getFeatureSettings>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFeatureSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFeatureSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFeatureSettings>>> = ({ signal }) => getFeatureSettings({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFeatureSettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetFeatureSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getFeatureSettings>>>
export type GetFeatureSettingsQueryError = ErrorType<unknown>


export function useGetFeatureSettings<TData = Awaited<ReturnType<typeof getFeatureSettings>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFeatureSettings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFeatureSettings>>,
          TError,
          Awaited<ReturnType<typeof getFeatureSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFeatureSettings<TData = Awaited<ReturnType<typeof getFeatureSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFeatureSettings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFeatureSettings>>,
          TError,
          Awaited<ReturnType<typeof getFeatureSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFeatureSettings<TData = Awaited<ReturnType<typeof getFeatureSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFeatureSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetFeatureSettings<TData = Awaited<ReturnType<typeof getFeatureSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFeatureSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetFeatureSettingsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetFeatureSettingsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getFeatureSettings>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFeatureSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFeatureSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFeatureSettings>>> = ({ signal }) => getFeatureSettings({ signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFeatureSettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetFeatureSettingsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getFeatureSettings>>>
export type GetFeatureSettingsSuspenseQueryError = ErrorType<unknown>


export function useGetFeatureSettingsSuspense<TData = Awaited<ReturnType<typeof getFeatureSettings>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFeatureSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFeatureSettingsSuspense<TData = Awaited<ReturnType<typeof getFeatureSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFeatureSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFeatureSettingsSuspense<TData = Awaited<ReturnType<typeof getFeatureSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFeatureSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetFeatureSettingsSuspense<TData = Awaited<ReturnType<typeof getFeatureSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFeatureSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetFeatureSettingsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getUpdateFeatureSettingsUrl = () => {




  return `/api/Settings/UpdateFeatureSettings`
}

export const updateFeatureSettings = async (features?: Features, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<void>(getUpdateFeatureSettingsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(features)
  }
);}





export const getUpdateFeatureSettingsMutationKey = () => ['updateFeatureSettings'] as const;

export const getUpdateFeatureSettingsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFeatureSettings>>, TError,UpdateFeatureSettingsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateFeatureSettings>>, TError,UpdateFeatureSettingsMutationVariables, TContext> => {

const mutationKey = getUpdateFeatureSettingsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateFeatureSettings>>, UpdateFeatureSettingsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  updateFeatureSettings(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateFeatureSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof updateFeatureSettings>>>
    export type UpdateFeatureSettingsMutationBody = BodyType<Features> | undefined
    export type UpdateFeatureSettingsMutationError = ErrorType<unknown>
    export type UpdateFeatureSettingsMutationVariables = {data?: BodyType<Features>}

    export const useUpdateFeatureSettings = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFeatureSettings>>, TError,UpdateFeatureSettingsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateFeatureSettings>>,
        TError,
        UpdateFeatureSettingsMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateFeatureSettingsMutationOptions(options), queryClient);
    }
    export const getGetExternalApiSettingsUrl = () => {




  return `/api/Settings/GetExternalApiSettings`
}

export const getExternalApiSettings = async ( options?: Parameters<typeof customInstance>[1]): Promise<ExternalApiSettings> => {

  return customInstance<ExternalApiSettings>(getGetExternalApiSettingsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetExternalApiSettingsQueryKey = () => {
    return [
    `/api/Settings/GetExternalApiSettings`
    ] as const;
    }


export const getGetExternalApiSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getExternalApiSettings>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExternalApiSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetExternalApiSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getExternalApiSettings>>> = ({ signal }) => getExternalApiSettings({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getExternalApiSettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetExternalApiSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getExternalApiSettings>>>
export type GetExternalApiSettingsQueryError = ErrorType<unknown>


export function useGetExternalApiSettings<TData = Awaited<ReturnType<typeof getExternalApiSettings>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExternalApiSettings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getExternalApiSettings>>,
          TError,
          Awaited<ReturnType<typeof getExternalApiSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetExternalApiSettings<TData = Awaited<ReturnType<typeof getExternalApiSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExternalApiSettings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getExternalApiSettings>>,
          TError,
          Awaited<ReturnType<typeof getExternalApiSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetExternalApiSettings<TData = Awaited<ReturnType<typeof getExternalApiSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExternalApiSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetExternalApiSettings<TData = Awaited<ReturnType<typeof getExternalApiSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExternalApiSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetExternalApiSettingsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetExternalApiSettingsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getExternalApiSettings>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getExternalApiSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetExternalApiSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getExternalApiSettings>>> = ({ signal }) => getExternalApiSettings({ signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getExternalApiSettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetExternalApiSettingsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getExternalApiSettings>>>
export type GetExternalApiSettingsSuspenseQueryError = ErrorType<unknown>


export function useGetExternalApiSettingsSuspense<TData = Awaited<ReturnType<typeof getExternalApiSettings>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getExternalApiSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetExternalApiSettingsSuspense<TData = Awaited<ReturnType<typeof getExternalApiSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getExternalApiSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetExternalApiSettingsSuspense<TData = Awaited<ReturnType<typeof getExternalApiSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getExternalApiSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetExternalApiSettingsSuspense<TData = Awaited<ReturnType<typeof getExternalApiSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getExternalApiSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetExternalApiSettingsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getUpdateExternalApiSettingsUrl = () => {




  return `/api/Settings/UpdateExternalApiSettings`
}

export const updateExternalApiSettings = async (externalApiSettings?: ExternalApiSettings, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<void>(getUpdateExternalApiSettingsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(externalApiSettings)
  }
);}





export const getUpdateExternalApiSettingsMutationKey = () => ['updateExternalApiSettings'] as const;

export const getUpdateExternalApiSettingsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateExternalApiSettings>>, TError,UpdateExternalApiSettingsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateExternalApiSettings>>, TError,UpdateExternalApiSettingsMutationVariables, TContext> => {

const mutationKey = getUpdateExternalApiSettingsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateExternalApiSettings>>, UpdateExternalApiSettingsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  updateExternalApiSettings(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateExternalApiSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof updateExternalApiSettings>>>
    export type UpdateExternalApiSettingsMutationBody = BodyType<ExternalApiSettings> | undefined
    export type UpdateExternalApiSettingsMutationError = ErrorType<unknown>
    export type UpdateExternalApiSettingsMutationVariables = {data?: BodyType<ExternalApiSettings>}

    export const useUpdateExternalApiSettings = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateExternalApiSettings>>, TError,UpdateExternalApiSettingsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateExternalApiSettings>>,
        TError,
        UpdateExternalApiSettingsMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateExternalApiSettingsMutationOptions(options), queryClient);
    }
    export const getGetDocusignSettingsUrl = () => {




  return `/api/Settings/GetDocusignSettings`
}

export const getDocusignSettings = async ( options?: Parameters<typeof customInstance>[1]): Promise<DocusignSettings> => {

  return customInstance<DocusignSettings>(getGetDocusignSettingsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetDocusignSettingsQueryKey = () => {
    return [
    `/api/Settings/GetDocusignSettings`
    ] as const;
    }


export const getGetDocusignSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getDocusignSettings>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocusignSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDocusignSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDocusignSettings>>> = ({ signal }) => getDocusignSettings({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDocusignSettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDocusignSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getDocusignSettings>>>
export type GetDocusignSettingsQueryError = ErrorType<unknown>


export function useGetDocusignSettings<TData = Awaited<ReturnType<typeof getDocusignSettings>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocusignSettings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocusignSettings>>,
          TError,
          Awaited<ReturnType<typeof getDocusignSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDocusignSettings<TData = Awaited<ReturnType<typeof getDocusignSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocusignSettings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocusignSettings>>,
          TError,
          Awaited<ReturnType<typeof getDocusignSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDocusignSettings<TData = Awaited<ReturnType<typeof getDocusignSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocusignSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetDocusignSettings<TData = Awaited<ReturnType<typeof getDocusignSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocusignSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDocusignSettingsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetDocusignSettingsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getDocusignSettings>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDocusignSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDocusignSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDocusignSettings>>> = ({ signal }) => getDocusignSettings({ signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDocusignSettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetDocusignSettingsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getDocusignSettings>>>
export type GetDocusignSettingsSuspenseQueryError = ErrorType<unknown>


export function useGetDocusignSettingsSuspense<TData = Awaited<ReturnType<typeof getDocusignSettings>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDocusignSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDocusignSettingsSuspense<TData = Awaited<ReturnType<typeof getDocusignSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDocusignSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDocusignSettingsSuspense<TData = Awaited<ReturnType<typeof getDocusignSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDocusignSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetDocusignSettingsSuspense<TData = Awaited<ReturnType<typeof getDocusignSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDocusignSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDocusignSettingsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getUpdateDocusignSettingsUrl = () => {




  return `/api/Settings/UpdateDocusignSettings`
}

export const updateDocusignSettings = async (docusignSettings?: DocusignSettings, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<void>(getUpdateDocusignSettingsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(docusignSettings)
  }
);}





export const getUpdateDocusignSettingsMutationKey = () => ['updateDocusignSettings'] as const;

export const getUpdateDocusignSettingsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDocusignSettings>>, TError,UpdateDocusignSettingsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateDocusignSettings>>, TError,UpdateDocusignSettingsMutationVariables, TContext> => {

const mutationKey = getUpdateDocusignSettingsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateDocusignSettings>>, UpdateDocusignSettingsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  updateDocusignSettings(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateDocusignSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof updateDocusignSettings>>>
    export type UpdateDocusignSettingsMutationBody = BodyType<DocusignSettings> | undefined
    export type UpdateDocusignSettingsMutationError = ErrorType<unknown>
    export type UpdateDocusignSettingsMutationVariables = {data?: BodyType<DocusignSettings>}

    export const useUpdateDocusignSettings = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDocusignSettings>>, TError,UpdateDocusignSettingsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateDocusignSettings>>,
        TError,
        UpdateDocusignSettingsMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateDocusignSettingsMutationOptions(options), queryClient);
    }
    export const getValidateDirectoryPathUrl = () => {




  return `/api/Settings/ValidateDirectoryPath`
}

export const validateDirectoryPath = async (validateDirectoryPathRequest?: ValidateDirectoryPathRequest, options?: Parameters<typeof customInstance>[1]): Promise<boolean> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<boolean>(getValidateDirectoryPathUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(validateDirectoryPathRequest)
  }
);}





export const getValidateDirectoryPathMutationKey = () => ['validateDirectoryPath'] as const;

export const getValidateDirectoryPathMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof validateDirectoryPath>>, TError,ValidateDirectoryPathMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof validateDirectoryPath>>, TError,ValidateDirectoryPathMutationVariables, TContext> => {

const mutationKey = getValidateDirectoryPathMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof validateDirectoryPath>>, ValidateDirectoryPathMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  validateDirectoryPath(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ValidateDirectoryPathMutationResult = NonNullable<Awaited<ReturnType<typeof validateDirectoryPath>>>
    export type ValidateDirectoryPathMutationBody = BodyType<ValidateDirectoryPathRequest> | undefined
    export type ValidateDirectoryPathMutationError = ErrorType<unknown>
    export type ValidateDirectoryPathMutationVariables = {data?: BodyType<ValidateDirectoryPathRequest>}

    export const useValidateDirectoryPath = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof validateDirectoryPath>>, TError,ValidateDirectoryPathMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof validateDirectoryPath>>,
        TError,
        ValidateDirectoryPathMutationVariables,
        TContext
      > => {
      return useMutation(getValidateDirectoryPathMutationOptions(options), queryClient);
    }
    export const getGetReminderSettingsUrl = () => {




  return `/api/Settings/GetReminderSettings`
}

export const getReminderSettings = async ( options?: Parameters<typeof customInstance>[1]): Promise<ReminderSettings> => {

  return customInstance<ReminderSettings>(getGetReminderSettingsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetReminderSettingsQueryKey = () => {
    return [
    `/api/Settings/GetReminderSettings`
    ] as const;
    }


export const getGetReminderSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getReminderSettings>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReminderSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetReminderSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getReminderSettings>>> = ({ signal }) => getReminderSettings({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getReminderSettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetReminderSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getReminderSettings>>>
export type GetReminderSettingsQueryError = ErrorType<unknown>


export function useGetReminderSettings<TData = Awaited<ReturnType<typeof getReminderSettings>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReminderSettings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReminderSettings>>,
          TError,
          Awaited<ReturnType<typeof getReminderSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReminderSettings<TData = Awaited<ReturnType<typeof getReminderSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReminderSettings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReminderSettings>>,
          TError,
          Awaited<ReturnType<typeof getReminderSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReminderSettings<TData = Awaited<ReturnType<typeof getReminderSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReminderSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetReminderSettings<TData = Awaited<ReturnType<typeof getReminderSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReminderSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetReminderSettingsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetReminderSettingsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getReminderSettings>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReminderSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetReminderSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getReminderSettings>>> = ({ signal }) => getReminderSettings({ signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReminderSettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetReminderSettingsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getReminderSettings>>>
export type GetReminderSettingsSuspenseQueryError = ErrorType<unknown>


export function useGetReminderSettingsSuspense<TData = Awaited<ReturnType<typeof getReminderSettings>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReminderSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReminderSettingsSuspense<TData = Awaited<ReturnType<typeof getReminderSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReminderSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReminderSettingsSuspense<TData = Awaited<ReturnType<typeof getReminderSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReminderSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetReminderSettingsSuspense<TData = Awaited<ReturnType<typeof getReminderSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReminderSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetReminderSettingsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getUpdateReminderSettingsUrl = () => {




  return `/api/Settings/UpdateReminderSettings`
}

export const updateReminderSettings = async (reminderSettings?: ReminderSettings, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<void>(getUpdateReminderSettingsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(reminderSettings)
  }
);}





export const getUpdateReminderSettingsMutationKey = () => ['updateReminderSettings'] as const;

export const getUpdateReminderSettingsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateReminderSettings>>, TError,UpdateReminderSettingsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateReminderSettings>>, TError,UpdateReminderSettingsMutationVariables, TContext> => {

const mutationKey = getUpdateReminderSettingsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateReminderSettings>>, UpdateReminderSettingsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  updateReminderSettings(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateReminderSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof updateReminderSettings>>>
    export type UpdateReminderSettingsMutationBody = BodyType<ReminderSettings> | undefined
    export type UpdateReminderSettingsMutationError = ErrorType<unknown>
    export type UpdateReminderSettingsMutationVariables = {data?: BodyType<ReminderSettings>}

    export const useUpdateReminderSettings = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateReminderSettings>>, TError,UpdateReminderSettingsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateReminderSettings>>,
        TError,
        UpdateReminderSettingsMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateReminderSettingsMutationOptions(options), queryClient);
    }
    export const getGetAdminAccessRestrictionSettingsUrl = () => {




  return `/api/Settings/GetAdminAccessRestrictionSettings`
}

export const getAdminAccessRestrictionSettings = async ( options?: Parameters<typeof customInstance>[1]): Promise<AdminAccessRestrictionSettings> => {

  return customInstance<AdminAccessRestrictionSettings>(getGetAdminAccessRestrictionSettingsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminAccessRestrictionSettingsQueryKey = () => {
    return [
    `/api/Settings/GetAdminAccessRestrictionSettings`
    ] as const;
    }


export const getGetAdminAccessRestrictionSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getAdminAccessRestrictionSettings>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminAccessRestrictionSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminAccessRestrictionSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminAccessRestrictionSettings>>> = ({ signal }) => getAdminAccessRestrictionSettings({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminAccessRestrictionSettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminAccessRestrictionSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminAccessRestrictionSettings>>>
export type GetAdminAccessRestrictionSettingsQueryError = ErrorType<unknown>


export function useGetAdminAccessRestrictionSettings<TData = Awaited<ReturnType<typeof getAdminAccessRestrictionSettings>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminAccessRestrictionSettings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminAccessRestrictionSettings>>,
          TError,
          Awaited<ReturnType<typeof getAdminAccessRestrictionSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminAccessRestrictionSettings<TData = Awaited<ReturnType<typeof getAdminAccessRestrictionSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminAccessRestrictionSettings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminAccessRestrictionSettings>>,
          TError,
          Awaited<ReturnType<typeof getAdminAccessRestrictionSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminAccessRestrictionSettings<TData = Awaited<ReturnType<typeof getAdminAccessRestrictionSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminAccessRestrictionSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAdminAccessRestrictionSettings<TData = Awaited<ReturnType<typeof getAdminAccessRestrictionSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminAccessRestrictionSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminAccessRestrictionSettingsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetAdminAccessRestrictionSettingsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getAdminAccessRestrictionSettings>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAdminAccessRestrictionSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminAccessRestrictionSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminAccessRestrictionSettings>>> = ({ signal }) => getAdminAccessRestrictionSettings({ signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAdminAccessRestrictionSettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetAdminAccessRestrictionSettingsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminAccessRestrictionSettings>>>
export type GetAdminAccessRestrictionSettingsSuspenseQueryError = ErrorType<unknown>


export function useGetAdminAccessRestrictionSettingsSuspense<TData = Awaited<ReturnType<typeof getAdminAccessRestrictionSettings>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAdminAccessRestrictionSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminAccessRestrictionSettingsSuspense<TData = Awaited<ReturnType<typeof getAdminAccessRestrictionSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAdminAccessRestrictionSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminAccessRestrictionSettingsSuspense<TData = Awaited<ReturnType<typeof getAdminAccessRestrictionSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAdminAccessRestrictionSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAdminAccessRestrictionSettingsSuspense<TData = Awaited<ReturnType<typeof getAdminAccessRestrictionSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAdminAccessRestrictionSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminAccessRestrictionSettingsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getSetAdminAccessRestrictionSettingsUrl = () => {




  return `/api/Settings/SetAdminAccessRestrictionSettings`
}

export const setAdminAccessRestrictionSettings = async (adminAccessRestrictionSettings?: AdminAccessRestrictionSettings, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<void>(getSetAdminAccessRestrictionSettingsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(adminAccessRestrictionSettings)
  }
);}





export const getSetAdminAccessRestrictionSettingsMutationKey = () => ['setAdminAccessRestrictionSettings'] as const;

export const getSetAdminAccessRestrictionSettingsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setAdminAccessRestrictionSettings>>, TError,SetAdminAccessRestrictionSettingsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof setAdminAccessRestrictionSettings>>, TError,SetAdminAccessRestrictionSettingsMutationVariables, TContext> => {

const mutationKey = getSetAdminAccessRestrictionSettingsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setAdminAccessRestrictionSettings>>, SetAdminAccessRestrictionSettingsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  setAdminAccessRestrictionSettings(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetAdminAccessRestrictionSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof setAdminAccessRestrictionSettings>>>
    export type SetAdminAccessRestrictionSettingsMutationBody = BodyType<AdminAccessRestrictionSettings> | undefined
    export type SetAdminAccessRestrictionSettingsMutationError = ErrorType<unknown>
    export type SetAdminAccessRestrictionSettingsMutationVariables = {data?: BodyType<AdminAccessRestrictionSettings>}

    export const useSetAdminAccessRestrictionSettings = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setAdminAccessRestrictionSettings>>, TError,SetAdminAccessRestrictionSettingsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setAdminAccessRestrictionSettings>>,
        TError,
        SetAdminAccessRestrictionSettingsMutationVariables,
        TContext
      > => {
      return useMutation(getSetAdminAccessRestrictionSettingsMutationOptions(options), queryClient);
    }
    export const getGetTrustedProxySettingsUrl = () => {




  return `/api/Settings/GetTrustedProxySettings`
}

export const getTrustedProxySettings = async ( options?: Parameters<typeof customInstance>[1]): Promise<TrustedProxySettings> => {

  return customInstance<TrustedProxySettings>(getGetTrustedProxySettingsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTrustedProxySettingsQueryKey = () => {
    return [
    `/api/Settings/GetTrustedProxySettings`
    ] as const;
    }


export const getGetTrustedProxySettingsQueryOptions = <TData = Awaited<ReturnType<typeof getTrustedProxySettings>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTrustedProxySettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTrustedProxySettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTrustedProxySettings>>> = ({ signal }) => getTrustedProxySettings({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTrustedProxySettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTrustedProxySettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getTrustedProxySettings>>>
export type GetTrustedProxySettingsQueryError = ErrorType<unknown>


export function useGetTrustedProxySettings<TData = Awaited<ReturnType<typeof getTrustedProxySettings>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTrustedProxySettings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTrustedProxySettings>>,
          TError,
          Awaited<ReturnType<typeof getTrustedProxySettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTrustedProxySettings<TData = Awaited<ReturnType<typeof getTrustedProxySettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTrustedProxySettings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTrustedProxySettings>>,
          TError,
          Awaited<ReturnType<typeof getTrustedProxySettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTrustedProxySettings<TData = Awaited<ReturnType<typeof getTrustedProxySettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTrustedProxySettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetTrustedProxySettings<TData = Awaited<ReturnType<typeof getTrustedProxySettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTrustedProxySettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTrustedProxySettingsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetTrustedProxySettingsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getTrustedProxySettings>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTrustedProxySettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTrustedProxySettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTrustedProxySettings>>> = ({ signal }) => getTrustedProxySettings({ signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTrustedProxySettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetTrustedProxySettingsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getTrustedProxySettings>>>
export type GetTrustedProxySettingsSuspenseQueryError = ErrorType<unknown>


export function useGetTrustedProxySettingsSuspense<TData = Awaited<ReturnType<typeof getTrustedProxySettings>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTrustedProxySettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTrustedProxySettingsSuspense<TData = Awaited<ReturnType<typeof getTrustedProxySettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTrustedProxySettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTrustedProxySettingsSuspense<TData = Awaited<ReturnType<typeof getTrustedProxySettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTrustedProxySettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetTrustedProxySettingsSuspense<TData = Awaited<ReturnType<typeof getTrustedProxySettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTrustedProxySettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTrustedProxySettingsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getSetTrustedProxySettingsUrl = () => {




  return `/api/Settings/SetTrustedProxySettings`
}

export const setTrustedProxySettings = async (trustedProxySettings?: TrustedProxySettings, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<void>(getSetTrustedProxySettingsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(trustedProxySettings)
  }
);}





export const getSetTrustedProxySettingsMutationKey = () => ['setTrustedProxySettings'] as const;

export const getSetTrustedProxySettingsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setTrustedProxySettings>>, TError,SetTrustedProxySettingsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof setTrustedProxySettings>>, TError,SetTrustedProxySettingsMutationVariables, TContext> => {

const mutationKey = getSetTrustedProxySettingsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setTrustedProxySettings>>, SetTrustedProxySettingsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  setTrustedProxySettings(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetTrustedProxySettingsMutationResult = NonNullable<Awaited<ReturnType<typeof setTrustedProxySettings>>>
    export type SetTrustedProxySettingsMutationBody = BodyType<TrustedProxySettings> | undefined
    export type SetTrustedProxySettingsMutationError = ErrorType<unknown>
    export type SetTrustedProxySettingsMutationVariables = {data?: BodyType<TrustedProxySettings>}

    export const useSetTrustedProxySettings = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setTrustedProxySettings>>, TError,SetTrustedProxySettingsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setTrustedProxySettings>>,
        TError,
        SetTrustedProxySettingsMutationVariables,
        TContext
      > => {
      return useMutation(getSetTrustedProxySettingsMutationOptions(options), queryClient);
    }
    export const getGetTixlySettingsUrl = () => {




  return `/api/Settings/GetTixlySettings`
}

export const getTixlySettings = async ( options?: Parameters<typeof customInstance>[1]): Promise<TixlySettings> => {

  return customInstance<TixlySettings>(getGetTixlySettingsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTixlySettingsQueryKey = () => {
    return [
    `/api/Settings/GetTixlySettings`
    ] as const;
    }


export const getGetTixlySettingsQueryOptions = <TData = Awaited<ReturnType<typeof getTixlySettings>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTixlySettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTixlySettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTixlySettings>>> = ({ signal }) => getTixlySettings({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTixlySettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTixlySettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getTixlySettings>>>
export type GetTixlySettingsQueryError = ErrorType<unknown>


export function useGetTixlySettings<TData = Awaited<ReturnType<typeof getTixlySettings>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTixlySettings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTixlySettings>>,
          TError,
          Awaited<ReturnType<typeof getTixlySettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTixlySettings<TData = Awaited<ReturnType<typeof getTixlySettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTixlySettings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTixlySettings>>,
          TError,
          Awaited<ReturnType<typeof getTixlySettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTixlySettings<TData = Awaited<ReturnType<typeof getTixlySettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTixlySettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetTixlySettings<TData = Awaited<ReturnType<typeof getTixlySettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTixlySettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTixlySettingsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetTixlySettingsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getTixlySettings>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTixlySettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTixlySettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTixlySettings>>> = ({ signal }) => getTixlySettings({ signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTixlySettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetTixlySettingsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getTixlySettings>>>
export type GetTixlySettingsSuspenseQueryError = ErrorType<unknown>


export function useGetTixlySettingsSuspense<TData = Awaited<ReturnType<typeof getTixlySettings>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTixlySettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTixlySettingsSuspense<TData = Awaited<ReturnType<typeof getTixlySettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTixlySettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTixlySettingsSuspense<TData = Awaited<ReturnType<typeof getTixlySettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTixlySettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetTixlySettingsSuspense<TData = Awaited<ReturnType<typeof getTixlySettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTixlySettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTixlySettingsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getUpdateTixlySettingsUrl = () => {




  return `/api/Settings/UpdateTixlySettings`
}

export const updateTixlySettings = async (tixlySettings?: TixlySettings, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<void>(getUpdateTixlySettingsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(tixlySettings)
  }
);}





export const getUpdateTixlySettingsMutationKey = () => ['updateTixlySettings'] as const;

export const getUpdateTixlySettingsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTixlySettings>>, TError,UpdateTixlySettingsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateTixlySettings>>, TError,UpdateTixlySettingsMutationVariables, TContext> => {

const mutationKey = getUpdateTixlySettingsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateTixlySettings>>, UpdateTixlySettingsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  updateTixlySettings(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateTixlySettingsMutationResult = NonNullable<Awaited<ReturnType<typeof updateTixlySettings>>>
    export type UpdateTixlySettingsMutationBody = BodyType<TixlySettings> | undefined
    export type UpdateTixlySettingsMutationError = ErrorType<unknown>
    export type UpdateTixlySettingsMutationVariables = {data?: BodyType<TixlySettings>}

    export const useUpdateTixlySettings = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTixlySettings>>, TError,UpdateTixlySettingsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateTixlySettings>>,
        TError,
        UpdateTixlySettingsMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateTixlySettingsMutationOptions(options), queryClient);
    }
    export const getGetLicenseDataUrl = () => {




  return `/api/Settings/GetLicenseData`
}

export const getLicenseData = async ( options?: Parameters<typeof customInstance>[1]): Promise<LicenseData> => {

  return customInstance<LicenseData>(getGetLicenseDataUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetLicenseDataQueryKey = () => {
    return [
    `/api/Settings/GetLicenseData`
    ] as const;
    }


export const getGetLicenseDataQueryOptions = <TData = Awaited<ReturnType<typeof getLicenseData>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLicenseData>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLicenseDataQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLicenseData>>> = ({ signal }) => getLicenseData({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLicenseData>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLicenseDataQueryResult = NonNullable<Awaited<ReturnType<typeof getLicenseData>>>
export type GetLicenseDataQueryError = ErrorType<unknown>


export function useGetLicenseData<TData = Awaited<ReturnType<typeof getLicenseData>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLicenseData>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLicenseData>>,
          TError,
          Awaited<ReturnType<typeof getLicenseData>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLicenseData<TData = Awaited<ReturnType<typeof getLicenseData>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLicenseData>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLicenseData>>,
          TError,
          Awaited<ReturnType<typeof getLicenseData>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLicenseData<TData = Awaited<ReturnType<typeof getLicenseData>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLicenseData>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetLicenseData<TData = Awaited<ReturnType<typeof getLicenseData>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLicenseData>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLicenseDataQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetLicenseDataSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getLicenseData>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLicenseData>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLicenseDataQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLicenseData>>> = ({ signal }) => getLicenseData({ signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLicenseData>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetLicenseDataSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getLicenseData>>>
export type GetLicenseDataSuspenseQueryError = ErrorType<unknown>


export function useGetLicenseDataSuspense<TData = Awaited<ReturnType<typeof getLicenseData>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLicenseData>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLicenseDataSuspense<TData = Awaited<ReturnType<typeof getLicenseData>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLicenseData>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLicenseDataSuspense<TData = Awaited<ReturnType<typeof getLicenseData>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLicenseData>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetLicenseDataSuspense<TData = Awaited<ReturnType<typeof getLicenseData>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLicenseData>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLicenseDataSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetProxySettingsUrl = () => {




  return `/api/Settings/GetProxySettings`
}

export const getProxySettings = async ( options?: Parameters<typeof customInstance>[1]): Promise<ProxySettings> => {

  return customInstance<ProxySettings>(getGetProxySettingsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetProxySettingsQueryKey = () => {
    return [
    `/api/Settings/GetProxySettings`
    ] as const;
    }


export const getGetProxySettingsQueryOptions = <TData = Awaited<ReturnType<typeof getProxySettings>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProxySettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProxySettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProxySettings>>> = ({ signal }) => getProxySettings({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProxySettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProxySettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getProxySettings>>>
export type GetProxySettingsQueryError = ErrorType<unknown>


export function useGetProxySettings<TData = Awaited<ReturnType<typeof getProxySettings>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProxySettings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProxySettings>>,
          TError,
          Awaited<ReturnType<typeof getProxySettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProxySettings<TData = Awaited<ReturnType<typeof getProxySettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProxySettings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProxySettings>>,
          TError,
          Awaited<ReturnType<typeof getProxySettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProxySettings<TData = Awaited<ReturnType<typeof getProxySettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProxySettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetProxySettings<TData = Awaited<ReturnType<typeof getProxySettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProxySettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProxySettingsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetProxySettingsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getProxySettings>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProxySettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProxySettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProxySettings>>> = ({ signal }) => getProxySettings({ signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProxySettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetProxySettingsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getProxySettings>>>
export type GetProxySettingsSuspenseQueryError = ErrorType<unknown>


export function useGetProxySettingsSuspense<TData = Awaited<ReturnType<typeof getProxySettings>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProxySettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProxySettingsSuspense<TData = Awaited<ReturnType<typeof getProxySettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProxySettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProxySettingsSuspense<TData = Awaited<ReturnType<typeof getProxySettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProxySettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetProxySettingsSuspense<TData = Awaited<ReturnType<typeof getProxySettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProxySettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProxySettingsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getUpdateProxySettingsUrl = () => {




  return `/api/Settings/UpdateProxySettings`
}

export const updateProxySettings = async (proxySettings?: ProxySettings, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<void>(getUpdateProxySettingsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(proxySettings)
  }
);}





export const getUpdateProxySettingsMutationKey = () => ['updateProxySettings'] as const;

export const getUpdateProxySettingsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProxySettings>>, TError,UpdateProxySettingsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateProxySettings>>, TError,UpdateProxySettingsMutationVariables, TContext> => {

const mutationKey = getUpdateProxySettingsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateProxySettings>>, UpdateProxySettingsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  updateProxySettings(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateProxySettingsMutationResult = NonNullable<Awaited<ReturnType<typeof updateProxySettings>>>
    export type UpdateProxySettingsMutationBody = BodyType<ProxySettings> | undefined
    export type UpdateProxySettingsMutationError = ErrorType<unknown>
    export type UpdateProxySettingsMutationVariables = {data?: BodyType<ProxySettings>}

    export const useUpdateProxySettings = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProxySettings>>, TError,UpdateProxySettingsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateProxySettings>>,
        TError,
        UpdateProxySettingsMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateProxySettingsMutationOptions(options), queryClient);
    }
    export const getGetActiveMailProviderSettingsUrl = () => {




  return `/api/Settings/GetActiveMailProviderSettings`
}

export const getActiveMailProviderSettings = async ( options?: Parameters<typeof customInstance>[1]): Promise<ActiveMailProviderSettings> => {

  return customInstance<ActiveMailProviderSettings>(getGetActiveMailProviderSettingsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetActiveMailProviderSettingsQueryKey = () => {
    return [
    `/api/Settings/GetActiveMailProviderSettings`
    ] as const;
    }


export const getGetActiveMailProviderSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getActiveMailProviderSettings>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActiveMailProviderSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetActiveMailProviderSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getActiveMailProviderSettings>>> = ({ signal }) => getActiveMailProviderSettings({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getActiveMailProviderSettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetActiveMailProviderSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getActiveMailProviderSettings>>>
export type GetActiveMailProviderSettingsQueryError = ErrorType<unknown>


export function useGetActiveMailProviderSettings<TData = Awaited<ReturnType<typeof getActiveMailProviderSettings>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActiveMailProviderSettings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActiveMailProviderSettings>>,
          TError,
          Awaited<ReturnType<typeof getActiveMailProviderSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetActiveMailProviderSettings<TData = Awaited<ReturnType<typeof getActiveMailProviderSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActiveMailProviderSettings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActiveMailProviderSettings>>,
          TError,
          Awaited<ReturnType<typeof getActiveMailProviderSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetActiveMailProviderSettings<TData = Awaited<ReturnType<typeof getActiveMailProviderSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActiveMailProviderSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetActiveMailProviderSettings<TData = Awaited<ReturnType<typeof getActiveMailProviderSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActiveMailProviderSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetActiveMailProviderSettingsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetActiveMailProviderSettingsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getActiveMailProviderSettings>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getActiveMailProviderSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetActiveMailProviderSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getActiveMailProviderSettings>>> = ({ signal }) => getActiveMailProviderSettings({ signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getActiveMailProviderSettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetActiveMailProviderSettingsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getActiveMailProviderSettings>>>
export type GetActiveMailProviderSettingsSuspenseQueryError = ErrorType<unknown>


export function useGetActiveMailProviderSettingsSuspense<TData = Awaited<ReturnType<typeof getActiveMailProviderSettings>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getActiveMailProviderSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetActiveMailProviderSettingsSuspense<TData = Awaited<ReturnType<typeof getActiveMailProviderSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getActiveMailProviderSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetActiveMailProviderSettingsSuspense<TData = Awaited<ReturnType<typeof getActiveMailProviderSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getActiveMailProviderSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetActiveMailProviderSettingsSuspense<TData = Awaited<ReturnType<typeof getActiveMailProviderSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getActiveMailProviderSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetActiveMailProviderSettingsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getSetActiveMailProviderSettingsUrl = () => {




  return `/api/Settings/SetActiveMailProviderSettings`
}

export const setActiveMailProviderSettings = async (activeMailProviderSettings?: ActiveMailProviderSettings, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<void>(getSetActiveMailProviderSettingsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(activeMailProviderSettings)
  }
);}





export const getSetActiveMailProviderSettingsMutationKey = () => ['setActiveMailProviderSettings'] as const;

export const getSetActiveMailProviderSettingsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setActiveMailProviderSettings>>, TError,SetActiveMailProviderSettingsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof setActiveMailProviderSettings>>, TError,SetActiveMailProviderSettingsMutationVariables, TContext> => {

const mutationKey = getSetActiveMailProviderSettingsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setActiveMailProviderSettings>>, SetActiveMailProviderSettingsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  setActiveMailProviderSettings(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetActiveMailProviderSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof setActiveMailProviderSettings>>>
    export type SetActiveMailProviderSettingsMutationBody = BodyType<ActiveMailProviderSettings> | undefined
    export type SetActiveMailProviderSettingsMutationError = ErrorType<unknown>
    export type SetActiveMailProviderSettingsMutationVariables = {data?: BodyType<ActiveMailProviderSettings>}

    export const useSetActiveMailProviderSettings = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setActiveMailProviderSettings>>, TError,SetActiveMailProviderSettingsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setActiveMailProviderSettings>>,
        TError,
        SetActiveMailProviderSettingsMutationVariables,
        TContext
      > => {
      return useMutation(getSetActiveMailProviderSettingsMutationOptions(options), queryClient);
    }
    export const getGetSsoSettingsUrl = () => {




  return `/api/Settings/GetSsoSettings`
}

export const getSsoSettings = async ( options?: Parameters<typeof customInstance>[1]): Promise<SsoSettings> => {

  return customInstance<SsoSettings>(getGetSsoSettingsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSsoSettingsQueryKey = () => {
    return [
    `/api/Settings/GetSsoSettings`
    ] as const;
    }


export const getGetSsoSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getSsoSettings>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSsoSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSsoSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSsoSettings>>> = ({ signal }) => getSsoSettings({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSsoSettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSsoSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getSsoSettings>>>
export type GetSsoSettingsQueryError = ErrorType<unknown>


export function useGetSsoSettings<TData = Awaited<ReturnType<typeof getSsoSettings>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSsoSettings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSsoSettings>>,
          TError,
          Awaited<ReturnType<typeof getSsoSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSsoSettings<TData = Awaited<ReturnType<typeof getSsoSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSsoSettings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSsoSettings>>,
          TError,
          Awaited<ReturnType<typeof getSsoSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSsoSettings<TData = Awaited<ReturnType<typeof getSsoSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSsoSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetSsoSettings<TData = Awaited<ReturnType<typeof getSsoSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSsoSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSsoSettingsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetSsoSettingsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getSsoSettings>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSsoSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSsoSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSsoSettings>>> = ({ signal }) => getSsoSettings({ signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSsoSettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetSsoSettingsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getSsoSettings>>>
export type GetSsoSettingsSuspenseQueryError = ErrorType<unknown>


export function useGetSsoSettingsSuspense<TData = Awaited<ReturnType<typeof getSsoSettings>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSsoSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSsoSettingsSuspense<TData = Awaited<ReturnType<typeof getSsoSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSsoSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSsoSettingsSuspense<TData = Awaited<ReturnType<typeof getSsoSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSsoSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetSsoSettingsSuspense<TData = Awaited<ReturnType<typeof getSsoSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSsoSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSsoSettingsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getSetSsoSettingsUrl = () => {




  return `/api/Settings/SetSsoSettings`
}

export const setSsoSettings = async (ssoSettings?: SsoSettings, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<void>(getSetSsoSettingsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(ssoSettings)
  }
);}





export const getSetSsoSettingsMutationKey = () => ['setSsoSettings'] as const;

export const getSetSsoSettingsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setSsoSettings>>, TError,SetSsoSettingsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof setSsoSettings>>, TError,SetSsoSettingsMutationVariables, TContext> => {

const mutationKey = getSetSsoSettingsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setSsoSettings>>, SetSsoSettingsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  setSsoSettings(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetSsoSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof setSsoSettings>>>
    export type SetSsoSettingsMutationBody = BodyType<SsoSettings> | undefined
    export type SetSsoSettingsMutationError = ErrorType<unknown>
    export type SetSsoSettingsMutationVariables = {data?: BodyType<SsoSettings>}

    export const useSetSsoSettings = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setSsoSettings>>, TError,SetSsoSettingsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setSsoSettings>>,
        TError,
        SetSsoSettingsMutationVariables,
        TContext
      > => {
      return useMutation(getSetSsoSettingsMutationOptions(options), queryClient);
    }
